<div class="d-flex flex-column align-items-center justify-content-center">
  <img class="mb-4 feature-mockup" [src]="vector" alt="dashpivot-feature-mockup" />
  <div class="d-flex justify-content-start flex-column">
    <div class="d-flex mb-2" *ngFor="let feature of features; index as i">
      <i class="cc-icon cc-icon-check align-middle mr-2"></i>
      <span class="feature-text font-weight-400">{{ feature }}</span>
    </div>
  </div>
</div>
